import { clsx } from 'clsx';

interface TruncatedTextProps {
  className?: string;
  capWidth?: 'small' | 'medium' | 'large';
  children?: string | string[];
}

export function TruncatedText({
  className,
  capWidth,
  children,
}: TruncatedTextProps): JSX.Element {
  return (
    <p
      className={clsx(
        'truncate',
        capWidth === 'small' && 'max-w-[100px]',
        capWidth === 'medium' && 'max-w-[250px]',
        capWidth === 'large' && 'max-w-[500px]',
        className,
      )}
      title={Array.isArray(children) ? children.join('') : children}
    >
      {children}
    </p>
  );
}
